import * as React from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout: React.FC<{
  children: React.ReactNode;
  location?: { pathname?: string };
}> = ({ children, location }) => {
  const isHome = location?.pathname === "/";
  return (
    <div id="site">
      <Header />
      <div id="site-content">
        <main id="site-main">{children}</main>
      </div>
      <Footer isHome={isHome} />
    </div>
  );
};

export default Layout;
